import { loadStripe } from '@stripe/stripe-js';

const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

if (!STRIPE_PUBLISHABLE_KEY) {
  // eslint-disable-next-line no-console
  console.warn(
    'REACT_APP_STRIPE_PUBLISHABLE_KEY is missing. Stripe Elements will be disabled until a key is provided.',
  );
}

// Load Stripe with error handling
let stripePromise = null;
if (STRIPE_PUBLISHABLE_KEY) {
  try {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
    // Handle promise rejection - wrap in a new promise that resolves to null on error
    stripePromise = stripePromise.catch((error) => {
      console.error('Failed to load Stripe.js:', error);
      return null;
    });
  } catch (error) {
    console.error('Failed to initialize Stripe:', error);
    stripePromise = Promise.resolve(null);
  }
}

export { stripePromise };
